/**
 * DemoBadge — visual chip that marks a professional listing as demo.
 *
 * Rendered on ProfessionalCard (top-right corner) and again on the
 * ProfessionalDetailRoute (inline chip beside the name).
 */
import React from "react";

export default function DemoBadge({ compact = false, className = "" }) {
  return (
    <span
      data-testid="professional-card-demo-badge"
      aria-label="Demo profile — shown for demonstration purposes only"
      className={
        (compact
          ? "text-[10px] px-2 py-0.5"
          : "text-[11px] px-2.5 py-1"
        ) +
        " inline-flex items-center gap-1 rounded-full font-semibold uppercase tracking-[0.14em] " +
        "bg-[rgba(167,139,250,0.16)] text-[var(--v2-accent-strong,#5D50C8)] " +
        "border border-[rgba(167,139,250,0.42)] " +
        className
      }
    >
      <span
        aria-hidden="true"
        className="inline-block h-1.5 w-1.5 rounded-full bg-[var(--v2-accent,#5D50C8)]"
      />
      Demo Profile
    </span>
  );
}
